// extracted by mini-css-extract-plugin
export default {"background":"hahKr","language-de":"fDOhh","language-en":"HiMKK","language-es":"b5ctL","language-fr":"Yv_Ml","language-it":"U6qQZ","language-nl":"d0FYm"};